import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Top } from './pages/Top'
import { GlobalStyle } from '@/styles/GlobalStyle'
import { theme } from '@/styles/theme'
import { ThemeProvider } from '@emotion/react'
import { ScreenLoader } from '@/components/loader/ScreenLoader'
import { ToastContainer } from 'react-toastify'
import { DestinationsListPage } from '@/pages/DestinationsListPage'
import { HealthInsurersListPage } from '@/pages/HealthInsurersListPage'
import { UsersListPage } from '@/pages/UsersListPage'
import { DestinationFormPage } from '@/pages/DestinationFormPage'
import { UserFormPage } from '@/pages/UserFormPage'
import { HealthInsurerDetailPage } from '@/pages/HealthInsurerDetailPage'
import { DestinationDetailPage } from '@/pages/DestinationDetailPage'
import { RequireAuth } from '@/features/RequireAuth'
import { HealthInsurerFormPage } from '@/pages/HealthInsurerFormPage'
import { UserDetailPage } from '@/pages/UserDetailPage'
import { LoginForm } from '@/features/Login'

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <ToastContainer />
        <GlobalStyle />
        <ScreenLoader />
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<LoginForm />} />
            <Route
              path="/top"
              element={
                <RequireAuth>
                  <Top />
                </RequireAuth>
              }
            />
            <Route
              path="/health-insurers"
              element={
                <RequireAuth>
                  <HealthInsurersListPage />
                </RequireAuth>
              }
            />
            <Route
              path="/health-insurers/:id/view"
              element={
                <RequireAuth>
                  <HealthInsurerDetailPage />
                </RequireAuth>
              }
            />
            <Route
              path="/health-insurers/new"
              element={
                <RequireAuth>
                  <HealthInsurerFormPage />
                </RequireAuth>
              }
            />
            <Route
              path="/health-insurers/:id/edit"
              element={
                <RequireAuth>
                  <HealthInsurerFormPage />
                </RequireAuth>
              }
            />
            <Route
              path="/destinations"
              element={
                <RequireAuth>
                  <DestinationsListPage />
                </RequireAuth>
              }
            />
            <Route
              path="/destinations/:id/view"
              element={
                <RequireAuth>
                  <DestinationDetailPage />
                </RequireAuth>
              }
            />
            <Route
              path="/destinations/new"
              element={
                <RequireAuth>
                  <DestinationFormPage />
                </RequireAuth>
              }
            />
            <Route
              path="/destinations/:id/edit"
              element={
                <RequireAuth>
                  <DestinationFormPage />
                </RequireAuth>
              }
            />
            <Route
              path="/users"
              element={
                <RequireAuth>
                  <UsersListPage />
                </RequireAuth>
              }
            />
            <Route
              path="/users/:id/view"
              element={
                <RequireAuth>
                  <UserDetailPage />
                </RequireAuth>
              }
            />
            <Route
              path="/users/new"
              element={
                <RequireAuth>
                  <UserFormPage />
                </RequireAuth>
              }
            />
            <Route
              path="/users/:id/edit"
              element={
                <RequireAuth>
                  <UserFormPage />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </>
  )
}

export default App
